const Search = {
    init() {
        const openSearchBtn = document.querySelector('.js-nav-primary-open-search');
        const searchCloseBtn = document.querySelector('.js-search-close');
        const searchInput = document.querySelector('.js-nav-search__form-input');
        searchInput.tabIndex = -1;
        searchCloseBtn.tabIndex = -1;
        if (openSearchBtn && searchCloseBtn) {
            openSearchBtn.addEventListener('click', () => {
                document.body.classList.add('nav-search--is-open');
                searchInput.focus();
                searchInput.tabIndex = 1;
                searchCloseBtn.tabIndex = 1;
            });
            searchCloseBtn.addEventListener('click', () => {
                document.body.classList.remove('nav-search--is-open');
                searchInput.tabIndex = -1;
                searchCloseBtn.tabIndex = -1;
            });
        }
    },
};

export default Search;
